// 吃瓜在线 - 站点演示内容数据（分类 / 热搜 / 直播讨论 / 专题 / 频道 / FAQ）

export type CategoryKey = "hot" | "ent" | "film" | "music" | "tech" | "live" | "life";

export interface Category {
  key: CategoryKey;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { key: "hot", name: "全站热榜", icon: "ri-fire-fill" },
  { key: "ent", name: "文娱圈", icon: "ri-mic-fill" },
  { key: "film", name: "影视剧", icon: "ri-clapperboard-fill" },
  { key: "music", name: "音乐现场", icon: "ri-music-2-fill" },
  { key: "tech", name: "科技瓜", icon: "ri-cpu-fill" },
  { key: "live", name: "直播间", icon: "ri-live-fill" },
  { key: "life", name: "生活圈", icon: "ri-vip-crown-2-fill" },
];

export interface FeedItem {
  id: string;
  cat: CategoryKey;
  tag: string;
  time: string;
  minutes: number;
  title: string;
  summary: string;
  heat: string;
  comments: string;
  likes: string;
  img?: string;
  imgAlt?: string;
  urgent?: boolean;
  trend?: "up" | "down" | "new" | "same";
}

export const feedItems: FeedItem[] = [
  {
    id: "f1",
    cat: "ent",
    tag: "文娱圈",
    time: "刚刚更新",
    minutes: 2,
    title: "年度仙侠大剧《云起长歌》今晚收官，全网播放量突破 60 亿",
    summary: "历经 28 天热播，剧情走向与演员演技再次刷屏热搜，制作方宣布将推出番外短剧，网友直呼「不够看」。",
    heat: "362 万",
    comments: "2.4 万",
    likes: "18.7 万",
    img: "https://readdy.ai/api/search-image?query=ancient%20chinese%20costume%20fantasy%20drama%20scene%20with%20flowing%20robes%20and%20misty%20mountains%2C%20cinematic%20warm%20evening%20light%2C%20editorial%20photography%2C%20rich%20color%20grade%2C%20high%20detail%2C%20dramatic%20atmosphere&width=420&height=300&seq=feed-f1-2026&orientation=landscape",
    imgAlt: "云起长歌仙侠剧收官场景",
    urgent: true,
    trend: "up",
  },
  {
    id: "f2",
    cat: "music",
    tag: "音乐现场",
    time: "刚刚更新",
    minutes: 4,
    title: "城市巡回音乐节官宣十城阵容，首站门票三分钟售罄",
    summary: "主办方公布首批参演名单后热度飙升，票价与开票时间同步公布，二手平台已出现加价转售提醒。",
    heat: "241 万",
    comments: "1.1 万",
    likes: "9.8 万",
    img: "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20dusk%20with%20warm%20stage%20lights%20and%20crowd%20silhouettes%2C%20lively%20concert%20atmosphere%2C%20editorial%20photography%2C%20soft%20warm%20tones%2C%20high%20detail%2C%20cinematic%20energy&width=420&height=300&seq=feed-f2-2026&orientation=landscape",
    imgAlt: "城市巡回音乐节现场舞台",
    urgent: true,
    trend: "new",
  },
  {
    id: "f3",
    cat: "tech",
    tag: "科技瓜",
    time: "刚刚更新",
    minutes: 6,
    title: "新一代 AI 影像旗舰官宣下月发布，主打端侧大模型创作",
    summary: "官方预告短片放出样张与算法演示，行业分析师预计将带动新一轮换机潮，话题热度持续走高。",
    heat: "198 万",
    comments: "8600",
    likes: "7.6 万",
    img: "https://readdy.ai/api/search-image?query=minimal%20smartphone%20product%20shot%20on%20warm%20cream%20surface%20with%20soft%20studio%20lighting%2C%20modern%20flagship%20device%2C%20clean%20editorial%20tech%20photography%2C%20high%20detail%2C%20subtle%20shadow&width=420&height=300&seq=feed-f3-2026&orientation=landscape",
    imgAlt: "新一代 AI 影像旗舰手机",
    trend: "up",
  },
  {
    id: "f4",
    cat: "film",
    tag: "影视剧",
    time: "刚刚更新",
    minutes: 9,
    title: "暑期档黑马喜剧《全员摆烂》上映四天票房破 8 亿",
    summary: "零主演流量加持下靠口碑逆袭，观众评分高达 9.1，片方宣布加开特效厅与午夜场排片。",
    heat: "176 万",
    comments: "7300",
    likes: "11.2 万",
    img: "https://readdy.ai/api/search-image?query=cheerful%20modern%20comedy%20movie%20still%20with%20playful%20characters%20in%20bright%20warm%20office%20setting%2C%20humorous%20editing%20style%2C%20editorial%20cinema%20photography%2C%20soft%20daylight%2C%20high%20detail&width=420&height=300&seq=feed-f4-2026&orientation=landscape",
    imgAlt: "暑期档喜剧电影全员摆烂剧照",
    urgent: true,
    trend: "up",
  },
  {
    id: "f5",
    cat: "live",
    tag: "直播间",
    time: "最近更新",
    minutes: 13,
    title: "头部主播带火县域好物，一场直播助销本地脐橙 40 万斤",
    summary: "溯源直播走进果园现场，下单峰值创新高，平台同步上线县域好物专区，拉动多地农产品上行。",
    heat: "133 万",
    comments: "5200",
    likes: "6.1 万",
    img: "https://readdy.ai/api/search-image?query=fresh%20orange%20oranges%20in%20wooden%20crate%20at%20sunny%20orchard%2C%20live%20commerce%20scene%2C%20warm%20natural%20sunlight%2C%20editorial%20food%20photography%2C%20vibrant%20fresh%20tones%2C%20high%20detail&width=420&height=300&seq=feed-f5-2026&orientation=landscape",
    imgAlt: "助农直播间里的新鲜脐橙",
    trend: "up",
  },
  {
    id: "f6",
    cat: "ent",
    tag: "文娱圈",
    time: "最近更新",
    minutes: 18,
    title: "出道十二年老牌男团官宣「毕业巡演」，粉丝集体开启青春回忆",
    summary: "组合发布长文感谢陪伴，站姐与后援会同步筹备应援物料，社交平台被「爷青回」刷屏。",
    heat: "118 万",
    comments: "3.1 万",
    likes: "15.4 万",
    trend: "down",
  },
  {
    id: "f7",
    cat: "life",
    tag: "生活圈",
    time: "最近更新",
    minutes: 22,
    title: "「多巴胺早餐」走红：年轻上班族用色彩搭配治愈通勤",
    summary: "继多巴胺穿搭之后，色彩明亮的早餐拼盘又火了，营养师提醒搭配要兼顾均衡与健康。",
    heat: "96 万",
    comments: "3900",
    likes: "4.8 万",
    trend: "up",
  },
  {
    id: "f8",
    cat: "film",
    tag: "影视剧",
    time: "最近更新",
    minutes: 26,
    title: "悬疑剧《无声证词》高开高走，导演剪辑版上线加长片段",
    summary: "多线叙事被网友逐帧解析，官方追加两段关键支线，讨论区仍在争论真正的幕后主使。",
    heat: "112 万",
    comments: "4.2 万",
    likes: "8.9 万",
    trend: "same",
  },
  {
    id: "f9",
    cat: "tech",
    tag: "科技瓜",
    time: "最近更新",
    minutes: 31,
    title: "开源大模型再升级，普通笔记本也能本地跑出高分生成",
    summary: "最新开源权重大幅降低硬件门槛，开发者在个人电脑上完成图文创作演示，社区反响热烈。",
    heat: "87 万",
    comments: "2100",
    likes: "3.6 万",
    trend: "down",
  },
  {
    id: "f10",
    cat: "music",
    tag: "音乐现场",
    time: "最近更新",
    minutes: 40,
    title: "原创歌手新专辑全网上线，空灵嗓音引乐评人集体打分",
    summary: "专辑主打歌旋律与编曲广受好评，实体黑胶首批预售已告罄，线上收听人次持续攀升。",
    heat: "79 万",
    comments: "1800",
    likes: "5.2 万",
    trend: "up",
  },
  {
    id: "f11",
    cat: "live",
    tag: "直播间",
    time: "最近更新",
    minutes: 55,
    title: "深夜电台直播成「睡眠搭子」：听雨声白噪音回放破亿",
    summary: "主打放松陪伴的白噪音直播走红，主播以轻缓语调读诗、放雨声，成为都市人的情绪出口。",
    heat: "64 万",
    comments: "940",
    likes: "2.9 万",
    trend: "new",
  },
  {
    id: "f12",
    cat: "life",
    tag: "生活圈",
    time: "最近更新",
    minutes: 68,
    title: "城市骑行热持续升温，周末滨江绿道迎来「骑行大军」",
    summary: "装备租赁、骑行路线分享与友好社交成为新话题，多座城市同步完善慢行系统与补给驿站。",
    heat: "58 万",
    comments: "760",
    likes: "2.1 万",
    trend: "same",
  },
  {
    id: "f13",
    cat: "ent",
    tag: "文娱圈",
    time: "最近更新",
    minutes: 80,
    title: "年度颁奖礼入围名单公布，多部口碑剧集角逐最佳",
    summary: "评委名单与入围作品引发热议，观众期待值拉满，票选通道将于下周正式开启。",
    heat: "51 万",
    comments: "1.6 万",
    likes: "4.4 万",
    trend: "up",
  },
  {
    id: "f14",
    cat: "film",
    tag: "影视剧",
    time: "最近更新",
    minutes: 95,
    title: "纪录片《味道的回声》聚焦街头小吃，唤醒味蕾记忆",
    summary: "摄制组走遍 12 座城市记录老店手艺，片尾一句话让无数观众破防，被赞「有温度的影像」",
    heat: "43 万",
    comments: "830",
    likes: "3.3 万",
    trend: "down",
  },
];

export interface RankItem {
  id: string;
  rank: number;
  title: string;
  heat: string;
  delta: string;
  cat: CategoryKey;
  up?: boolean;
}

export const rankList: RankItem[] = [
  { id: "r1", rank: 1, title: "《云起长歌》收官夜结局讨论", heat: "362 万", delta: "↑ 12", cat: "ent", up: true },
  { id: "r2", rank: 2, title: "城市音乐节首站门票售罄", heat: "288 万", delta: "↑ 8", cat: "music", up: true },
  { id: "r3", rank: 3, title: "AI 影像旗舰官宣下月发布", heat: "245 万", delta: "↑ 5", cat: "tech", up: true },
  { id: "r4", rank: 4, title: "喜剧《全员摆烂》票房口碑双丰收", heat: "203 万", delta: "↑ 15", cat: "film", up: true },
  { id: "r5", rank: 5, title: "县域好物助农直播单场破纪录", heat: "176 万", delta: "↓ 2", cat: "live" },
  { id: "r6", rank: 6, title: "老牌男团「毕业巡演」官宣", heat: "154 万", delta: "↑ 3", cat: "ent", up: true },
  { id: "r7", rank: 7, title: "多巴胺早餐治愈式走红", heat: "128 万", delta: "↑ 6", cat: "life", up: true },
  { id: "r8", rank: 8, title: "悬疑剧《无声证词》幕后解析", heat: "109 万", delta: "↓ 1", cat: "film" },
  { id: "r9", rank: 9, title: "开源大模型普通电脑本地跑通", heat: "88 万", delta: "↓ 4", cat: "tech" },
  { id: "r10", rank: 10, title: "深夜白噪音电台回放破亿", heat: "72 万", delta: "新上榜", cat: "live" },
];

export interface LiveMsg {
  id: string;
  name: string;
  text: string;
  time: string;
  hot?: boolean;
}

export const liveMessages: LiveMsg[] = [
  { id: "l1", name: "熬夜冠军", text: "云起长歌结局我哭了一整包纸巾😭", time: "刚刚", hot: true },
  { id: "l2", name: "前排吃瓜群众", text: "音乐节票也太快没了吧，没抢到气死", time: "12 秒前" },
  { id: "l3", name: "理性讨论员", text: "AI 手机这代算法确实顶，本地跑真香", time: "25 秒前" },
  { id: "l4", name: "追剧小能手", text: "无声证词导演版我刷了三遍，细节拉满", time: "38 秒前" },
  { id: "l5", name: "松弛感代表", text: "多巴胺早餐我连续做了一周，心情up", time: "50 秒前" },
  { id: "l6", name: "早睡困难户", text: "白噪音电台真的是我本命，秒入睡", time: "1 分钟前" },
  { id: "l7", name: "老粉丝上线", text: "男团毕业巡演必须去，青春结束前再疯一次", time: "1 分钟前" },
];

export interface FeatureArticle {
  id: string;
  cat: CategoryKey;
  tag: string;
  title: string;
  excerpt: string;
  reads: string;
  duration: string;
  img: string;
  imgAlt: string;
}

export const featureArticles: FeatureArticle[] = [
  {
    id: "fa1",
    cat: "live",
    tag: "深度专题",
    title: "直播间里消失的「真实感」：我们如何被算法推着向前",
    excerpt:
      "从「3、2、1 上链接」到「家人们理性消费」，直播电商用十年跑完一个轮回。本文走进主播、运营与消费者三方视角，拆解一场秒没背后的流量逻辑、信任成本与情绪价值。",
    reads: "186 万",
    duration: "12 分钟",
    img: "https://readdy.ai/api/search-image?query=modern%20broadcast%20studio%20interior%20with%20ring%20lights%20and%20screens%20blurred%20in%20foreground%2C%20warm%20cinematic%20lighting%2C%20editorial%20documentary%20photography%2C%20deep%20depth%20of%20field%2C%20high%20detail%2C%20introspective%20mood&width=1200&height=675&seq=feature-fa1-2026&orientation=landscape",
    imgAlt: "直播电商行业深度报道配图",
  },
  {
    id: "fa2",
    cat: "ent",
    tag: "深度专题",
    title: "一部爆款剧背后：热搜是造出来的，还是长出来的？",
    excerpt:
      "从「自来水安利」到「数据飞轮」，我们拆解口碑剧集的出圈路径。究竟哪些热度真实可感，哪些只是营销脚本？这一次，我们和编剧、剪辑、舆情从业者聊了聊。",
    reads: "143 万",
    duration: "9 分钟",
    img: "https://readdy.ai/api/search-image?query=film%20editing%20suite%20with%20warm%20monitor%20glow%20and%20timeline%20clips%2C%20behind%20the%20scenes%20of%20tv%20series%20production%2C%20editorial%20documentary%20photography%2C%20cinematic%20warm%20tone%2C%20high%20detail&width=1200&height=675&seq=feature-fa2-2026&orientation=landscape",
    imgAlt: "影视剧集幕后制作报道配图",
  },
];

export interface ChannelBlock {
  id: string;
  cat: CategoryKey;
  name: string;
  desc: string;
  img: string;
  imgAlt: string;
  hot: string;
  items: { title: string; time: string }[];
}

export const channels: ChannelBlock[] = [
  {
    id: "c1",
    cat: "ent",
    name: "文娱圈速报",
    desc: "艺人动态 / 综艺现场 / 颁奖典礼",
    hot: "热议中",
    img: "https://readdy.ai/api/search-image?query=red%20carpet%20award%20ceremony%20moment%20with%20spotlights%20and%20warm%20golden%20bokeh%2C%20entertainment%20news%20photography%2C%20glamorous%20warm%20tones%2C%20editorial%20cinematic%2C%20high%20detail&width=640&height=420&seq=channel-c1-2026&orientation=landscape",
    imgAlt: "文娱圈红毯盛典现场",
    items: [
      { title: "新晋小花官宣加盟国民综艺常驻阵容", time: "24 分钟前" },
      { title: "顶流音乐人晒出巡演彩排幕后花絮", time: "1 小时前" },
      { title: "颁奖礼红毯造型盘点：谁的穿搭最出圈", time: "2 小时前" },
    ],
  },
  {
    id: "c2",
    cat: "live",
    name: "直播间风向",
    desc: "带货现场 / 助农溯源 / 白噪音电台",
    hot: "热度↑",
    img: "https://readdy.ai/api/search-image?query=cozy%20warm%20home%20studio%20live%20streaming%20setup%20with%20softbox%20and%20camera%2C%20warm%20evening%20ambience%2C%20editorial%20photography%2C%20relaxing%20lifestyle%20vibe%2C%20high%20detail&width=640&height=420&seq=channel-c2-2026&orientation=landscape",
    imgAlt: "直播间布置与直播场景",
    items: [
      { title: "溯源直播带火当季鲜果，单场破 40 万斤", time: "18 分钟前" },
      { title: "白噪音电台回放破亿，成新一代睡眠搭子", time: "55 分钟前" },
      { title: "主播直播间还原地道夜市烟火气", time: "3 小时前" },
    ],
  },
  {
    id: "c3",
    cat: "tech",
    name: "科技大瓜",
    desc: "新机发布 / 大模型 / 智能硬件",
    hot: "讨论中",
    img: "https://readdy.ai/api/search-image?query=futuristic%20smart%20devices%20and%20circuit%20details%20arranged%20on%20warm%20cream%20desk%2C%20minimal%20tech%20editorial%20photography%2C%20soft%20natural%20light%2C%20clean%20composition%2C%20high%20detail&width=640&height=420&seq=channel-c3-2026&orientation=landscape",
    imgAlt: "科技数码产品桌面特写",
    items: [
      { title: "AI 影像旗舰样张曝光，端侧创作成卖点", time: "6 分钟前" },
      { title: "开源大模型社区更新，笔记本本地可跑", time: "31 分钟前" },
      { title: "智能穿戴新品主打全天候健康监测", time: "4 小时前" },
    ],
  },
  {
    id: "c4",
    cat: "film",
    name: "影视一线",
    desc: "热播剧集 / 院线动态 / 纪录片",
    hot: "热播中",
    img: "https://readdy.ai/api/search-image?query=movie%20theater%20auditorium%20with%20warm%20screen%20glow%20and%20empty%20red%20seats%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20warm%20ambient%20lighting%2C%20high%20detail%2C%20dramatic%20mood&width=640&height=420&seq=channel-c4-2026&orientation=landscape",
    imgAlt: "影院放映厅与银幕",
    items: [
      { title: "《全员摆烂》口碑发酵，排片加场", time: "9 分钟前" },
      { title: "悬疑剧导演剪辑版上线加长片段", time: "26 分钟前" },
      { title: "街头小吃纪录片唤醒味蕾记忆", time: "1 小时前" },
    ],
  },
  {
    id: "c5",
    cat: "music",
    name: "音乐现场",
    desc: "新歌发布 / 巡演票务 / 乐评速递",
    hot: "抢票中",
    img: "https://readdy.ai/api/search-image?query=vintage%20vinyl%20records%20and%20microphone%20on%20warm%20wooden%20desk%2C%20music%20studio%20ambience%2C%20editorial%20photography%2C%20soft%20window%20light%2C%20high%20detail%2C%20nostalgic%20warm%20tone&width=640&height=420&seq=channel-c5-2026&orientation=landscape",
    imgAlt: "音乐专辑唱片与麦克风",
    items: [
      { title: "城市巡回音乐节阵容官宣十城", time: "4 分钟前" },
      { title: "原创歌手新专辑上线，黑胶告罄", time: "40 分钟前" },
      { title: "年度音乐盛典年度歌单票选开启", time: "5 小时前" },
    ],
  },
  {
    id: "c6",
    cat: "life",
    name: "生活潮流",
    desc: "饮食穿搭 / 城市漫游 / 情绪价值",
    hot: "关注↑",
    img: "https://readdy.ai/api/search-image?query=colorful%20healthy%20breakfast%20bowl%20flat%20lay%20on%20warm%20towel%20with%20bright%20fresh%20ingredients%2C%20lifestyle%20editorial%20photography%2C%20soft%20morning%20light%2C%20vibrant%20yet%20warm%20tones%2C%20high%20detail&width=640&height=420&seq=channel-c6-2026&orientation=landscape",
    imgAlt: "多彩健康的早餐摆盘",
    items: [
      { title: "多巴胺早餐走红，用色彩治愈通勤", time: "22 分钟前" },
      { title: "周末城市骑行升温，滨江绿道人气旺", time: "1 小时前" },
      { title: "「情绪价值」成年轻人社交关键词", time: "6 小时前" },
    ],
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "「吃瓜在线」的信息来源是什么？",
    a: "我们实时汇聚全网公开平台上的热点话题与官方公告，并由编辑部进行核实、交叉比对后以时间线的形式呈现。对尚未有权威信源佐证的内容，我们会明确标注「跟进中」，并在事件出现新进展时第一时间更新。",
  },
  {
    q: "为什么有些热点会标注「跟进中」？",
    a: "热点事件往往处于持续演进的状态，早期信息可能不完整。为了不误导读者，凡是事件尚未有当事方或权威机构出面确认的内容，我们都会加上「跟进中」标识，并持续滚动补充最新进展，直到事件全貌清晰。",
  },
  {
    q: "我的平台内容被收录了，如何申请处理？",
    a: "如果你发现站内收录了与你有直接关联且希望更正或移除的内容，请通过页面底部的官方邮箱与我们联系，并附上相关证明材料与内容链接。我们承诺在核验后的 24 小时内给出处理反馈。",
  },
  {
    q: "「吃瓜在线」会制造或放大矛盾吗？",
    a: "不会。我们的编辑原则是「还原、求证、不站队」：只呈现公开可见的事实与多方声音，不做情绪化引导，也绝不编造或放大冲突。我们希望提供的是一份尽可能客观的热点时间线，而不是情绪的推手。",
  },
  {
    q: "如何第一时间收到重大热点更新？",
    a: "你可以在站内启用「实时推送」提醒，也可以收藏常用栏目。每逢重大进展，我们都会用顶部滚动公告栏与「刚刚更新」标签第一时间同步，确保你不错过任何关键节点。",
  },
  {
    q: "我也可以参与投稿或提供线索吗？",
    a: "当然可以。欢迎通过站内「我要投稿」或官方邮箱向我们提供值得关注的事件线索与独家观察，前提是内容真实、有据可查。审核通过的线索我们会注明来源并尽快跟进报道。",
  },
];

export interface StatItem {
  value: string;
  label: string;
}

export const stats: StatItem[] = [
  { value: "24h", label: "全天滚动更新" },
  { value: "12+", label: "热门栏目频道" },
  { value: "600+", label: "每日热点聚合" },
  { value: "30s", label: "平均响应跟进" },
];

export const principles = [
  {
    icon: "ri-focus-3-line",
    title: "还原事实",
    desc: "以时间线还原事件全貌，呈现多方声音，杜绝断章取义。",
  },
  {
    icon: "ri-verified-badge-line",
    title: "先求证再发布",
    desc: "优先采用官方公告与一手信源，未证实内容明确标注。",
  },
  {
    icon: "ri-scales-3-line",
    title: "客观不站队",
    desc: "不做情绪化引导，不放大矛盾，尊重每一位当事人。",
  },
  {
    icon: "ri-eye-off-line",
    title: "尊重隐私边界",
    desc: "涉及个人信息坚决打码，拒绝传播与商业无关的隐私内容。",
  },
];

export const editorialPicks = [
  {
    id: "e1",
    tag: "编辑精选",
    title: "《云起长歌》结局解析：三条伏笔埋了整整二十集",
    reads: "92 万",
  },
  {
    id: "e2",
    tag: "现场直击",
    title: "我在音乐节首站现场：万人合唱与大雨中的浪漫",
    reads: "76 万",
  },
  {
    id: "e3",
    tag: "行业观察",
    title: "县域好物为什么能在直播间卖爆？三层逻辑拆解",
    reads: "58 万",
  },
  {
    id: "e4",
    tag: "声音记录",
    title: "十二年老粉写给「毕业巡演」的一封信",
    reads: "41 万",
  },
];